import { Navigate, useLocation } from 'react-router-dom'

import LoadingComponent from 'components/LoadingComponent'

import usePermission from 'hooks/useHasPermission'

import { useUser } from 'UserContext'

const PrivateRoute = ({ children, required = [] }) => {
  const { user, isLoading } = useUser()
  const location = useLocation()
  const hasPermission = usePermission()
  if (isLoading) return <LoadingComponent />

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // if (hasPermission(required)) {
  //   return <Navigate to="/forbidden" replace />
  // }

  return children
}

export default PrivateRoute
